import { render, staticRenderFns } from "./LayoutGame.vue?vue&type=template&id=fea06c62&scoped=true&"
import script from "./LayoutGame.vue?vue&type=script&lang=js&"
export * from "./LayoutGame.vue?vue&type=script&lang=js&"
import style0 from "./LayoutGame.vue?vue&type=style&index=0&id=fea06c62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea06c62",
  null
  
)

export default component.exports